import React, { useEffect, useRef } from "react";
import { ArrowRight } from "lucide-react";
import { HERO } from "../mock";

export default function Hero() {
  const ref = useRef(null);

  useEffect(() => {
    const els = ref.current.querySelectorAll(".reveal");
    els.forEach((el, i) => setTimeout(() => el.classList.add("in-view"), 250 + i * 160));
  }, []);

  return (
    <section id="top" ref={ref} className="relative min-h-screen sunset-gradient grain overflow-hidden">
      <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10 min-h-screen flex flex-col justify-center items-center">
        <div className="max-w-[900px] flex flex-col items-center text-center">
          <p className="reveal font-display uppercase tracking-[0.35em] text-[12px] md:text-[13px] mb-6" style={{ color: "#b1cdff" }}>
            {HERO.eyebrow}
          </p>
          <h1 className="reveal font-display font-semibold leading-[0.98] text-white text-[40px] sm:text-[62px] md:text-[76px] lg:text-[84px]">
            {HERO.title.join(" ")}
          </h1>
          <p className="reveal mt-8 max-w-2xl text-[17px] md:text-[20px] leading-relaxed" style={{ color: "#eaf1ff" }}>
            {HERO.subtitle}
          </p>
          <div className="reveal mt-10 flex flex-wrap items-center justify-center gap-4">
            <a href={HERO.primaryCta.href} className="group inline-flex items-center gap-2 rounded-full px-8 py-3.5 text-[15px] font-semibold text-white transition-all duration-200 hover:-translate-y-0.5" style={{ background: "#e55b36" }}>
              {HERO.primaryCta.label}
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </a>
            <a href={HERO.secondaryCta.href} className="inline-flex items-center rounded-full px-8 py-3.5 text-[15px] font-semibold transition-all duration-200 hover:-translate-y-0.5" style={{ border: "1.5px solid rgba(255,255,255,0.6)", color: "#ffffff" }}>
              {HERO.secondaryCta.label}
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-[11px] uppercase tracking-[0.3em]" style={{ color: "#00101f" }}>Scroll</span>
        <span className="h-10 w-[1.5px]" style={{ background: "#00101f", opacity: 0.5 }} />
      </div>
    </section>
  );
}
